// import { lazy } from "react";
// import Loadable from "app/components/Loadable";

// const NotFound = Loadable(lazy(() => import("./NotFound")));

// const FirebaseLogin = Loadable(lazy(() => import("./login/Login")));

// // const FirebaseLogin = Loadable(lazy(() => import("./login/loginazure")));


// // const JwtLogin = Loadable(lazy(() => import("./login/JwtLogin")));
// // const JwtRegister = Loadable(lazy(() => import("./register/JwtRegister")));

// // const Auth0Login = Loadable(lazy(() => import("./login/Auth0Login")));

// const sessionRoutes = [
//   { path: "/session/signin", element: <FirebaseLogin /> },
//   { path: "*", element: <NotFound /> }
// ];

// export default sessionRoutes;



import { lazy } from "react";
import Loadable from "app/components/Loadable";
import config from "../../common/mis";

const NotFound = Loadable(lazy(() => import("./NotFound")));

// Dynamically import the login component based on environment variable

let LoginComponent;
const { react_Login_With_url } = config.react_loging;
// Conditionally load the correct login component based on the flag
if (react_Login_With_url === "azure") {
  LoginComponent = Loadable(lazy(() => import("./login/loginazure")));
} else {
  LoginComponent = Loadable(lazy(() => import("./login/Login")));
}

const sessionRoutes = [
  { path: "/session/signin", element: <LoginComponent /> },
  { path: "*", element: <NotFound /> }
];

export default sessionRoutes;
